module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_softangled.f685b425.png";